module.exports = __webpack_public_path__ + "img/no-backdrop-image.43056ad0.jpg";